<template>
  <c-dialog :title="$t('user.title')" :visible="visible" @close="visible = false" :append-to-body="true" width="720px">
    <div slot="content" class="account-info">
      <div class="account-left">
        <label class="brand-logo">
          <span>{{ $t('user.logo') }}</span>
        </label>
        <div class="brand-logo-content">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :on-success="handleBrandIconUrlSuccess"
            :before-upload="handleBeforeUpload"
            :http-request="handlePublicUploadRequest"
          >
            <el-image v-if="previewBrandIconUrl" :src="previewBrandIconUrl" class="brand-icon"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon brand-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="account-right">
        <el-form size="small" label-width="105px" label-position="left">
          <el-form-item :label="$t('user.name')">
            <el-input v-model="form.merchantName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.short_name')">
            <el-input v-model="form.shortName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.enable')">
            <el-button-group>
              <el-button :type="form.enable === 0 ? 'info' : 'primary'" size="mini" @click="setEnableOnClick(1)">
                <span>{{ $t('open') }}</span>
              </el-button>
              <el-button :type="form.enable === 0 ? 'primary' : 'info'" size="mini" @click="setEnableOnClick(0)">
                <span>{{ $t('close') }}</span>
              </el-button>
            </el-button-group>
          </el-form-item>
          <el-form-item :label="$t('user.web_tips')">
            <el-button type="primary" @click="copyLoginUrlOnClick">
              <span>{{ $t('user.copy') }}</span>
            </el-button>
            <div style="font-size: 12px; color: #d3d3d3">{{ copyLoginLinkUrl }}</div>
          </el-form-item>
          <el-form-item :label="$t('user.login')">
            <el-input v-model="form.brandName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.login_title')" style="margin-bottom: 0">
            <el-input v-model="form.systemName"></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: right; margin-top: 30px">
          <loading-button type="primary" size="small" @click="updateMerchantInfo">
            <span>{{ $t('user.update') }}</span>
          </loading-button>
        </div>
      </div>
    </div>
  </c-dialog>
</template>
<script>
import { Message } from 'element-ui'
import LoadingButton from '@/components/Buttons/loading-button'

export default {
  components: { LoadingButton },
  name: 'EditAccountInfo',
  props: {
    modelValue: Boolean
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  created() {},
  data() {
    return {
      form: {
        merchantName: '',
        shortName: '',
        logoUrl: '',
        systemName: '',
        brandName: '',
        enable: 1,
        brandIconUrl: ''
      }
    }
  },
  watch: {
    modelValue: {
      handler(oldV, newV) {
        if (oldV) {
          const merchantInfo = this.$store.state.MerchantMe.merchantInfo
          if (!merchantInfo) {
            // 如果 merchantInfo 为 null，先获取数据
            this.fetchMerchantInfo()
            return
          }
          this.form.merchantName = merchantInfo.name || ''
          this.form.shortName = merchantInfo.shortName || ''
          if (merchantInfo.merchantHomePage) {
            this.form.systemName = merchantInfo.merchantHomePage.systemName || ''
            this.form.brandName = merchantInfo.merchantHomePage.brandName || ''
            this.form.enable = merchantInfo.merchantHomePage.enable !== undefined ? merchantInfo.merchantHomePage.enable : 1
            this.form.brandIconUrl = merchantInfo.merchantHomePage.brandIconUrl || ''
          }
        }
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    },
    previewBrandIconUrl() {
      return this.$store.state.MerchantOssUpload.publicDataHost && this.form.brandIconUrl && this.form.brandIconUrl !== ''
        ? `${this.$store.state.MerchantOssUpload.publicDataHost}/${this.form.brandIconUrl}`
        : ''
    },
    copyLoginLinkUrl() {
      const merchantInfo = this.$store.state.MerchantMe.merchantInfo
      if (!merchantInfo || !merchantInfo.merchantId) {
        return ''
      }
      return `${window.location.protocol}//${window.location.host}/#/?merchantId=${merchantInfo.merchantId}`
    }
  },
  methods: {
    async fetchMerchantInfo() {
      try {
        await this.$store.dispatch('MerchantMe/getMerchantInfo')
        // 获取成功后，重新设置表单数据
        const merchantInfo = this.$store.state.MerchantMe.merchantInfo
        if (merchantInfo) {
          this.form.merchantName = merchantInfo.name || ''
          this.form.shortName = merchantInfo.shortName || ''
          if (merchantInfo.merchantHomePage) {
            this.form.systemName = merchantInfo.merchantHomePage.systemName || ''
            this.form.brandName = merchantInfo.merchantHomePage.brandName || ''
            this.form.enable = merchantInfo.merchantHomePage.enable !== undefined ? merchantInfo.merchantHomePage.enable : 1
            this.form.brandIconUrl = merchantInfo.merchantHomePage.brandIconUrl || ''
          }
        }
      } catch (error) {
        Message({
          message: error.message || '获取商户信息失败',
          type: 'error',
          duration: 10 * 1000
        })
      }
    },
    async copyLoginUrlOnClick() {
      try {
        const url = this.copyLoginLinkUrl
        if (!url) {
          Message({
            message: '商户信息未加载，请稍后再试',
            type: 'warning',
            duration: 10 * 1000
          })
          return
        }
        await this.$copyText(url)
        Message({
          message: '复制成功',
          type: 'success',
          duration: 10 * 1000
        })
      } catch (error) {
        Message({
          message: error.message,
          type: 'error',
          duration: 10 * 1000
        })
      }
    },
    async setEnableOnClick(enable) {
      this.form.enable = enable
    },
    async updateMerchantInfo(done) {
      try {
        await this.$store.dispatch('MerchantMe/saveMerchantInfo', this.form)
        Message({
          message: '更新成功',
          type: 'success',
          duration: 10 * 1000
        })
      } catch (error) {
        Message({
          message: error.message,
          type: 'error',
          duration: 10 * 1000
        })
      }
      done()
    },
    /**
     * 上传之前校验
     */
    async handleBeforeUpload(file) {
      const isJPEG = file.type === 'image/jpeg'
      const isJPG = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPEG && !isJPG && !isPNG) {
        Message({
          message: '图片格式不正确，只能使用 jpg、jpeg、png',
          type: 'error',
          duration: 10 * 1000
        })
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return (isJPEG || isJPG || isPNG) && isLt5M
    },
    /**
     * 上传公共文件
     */
    async handlePublicUploadRequest(option) {
      const result = await this.$store.dispatch('MerchantOssUpload/uploadPublicFile', option.file)
      return result
    },
    /**
     * 上传成功
     */
    async handleBrandIconUrlSuccess(res, file) {
      if (!res || !res.host || !res.originURL) {
        Message({
          message: '返回值异常',
          type: 'error',
          duration: 10 * 1000
        })
        return
      }
      this.form.brandIconUrl = res.originURL
    }
  }
}
</script>
<style lang="scss" scoped>
.account-info {
  display: flex;
}

.account-left {
  padding-right: 30px;
  border-right: 1px solid #eee;
  padding-top: 9px;
}

.brand-logo {
  font-size: 13px;
}

.brand-logo-content {
  flex-shrink: 0;
  width: 135px;
  height: 135px;
  margin-top: 15px;
  border-radius: 4px;
  border: 1px solid #dddddd;
  text-align: center;
}

.account-right {
  padding-left: 30px;
  flex: 1;
}

/**
* 上传样式
*/
.avatar-uploader .el-upload {
  // border: 1px dashed #d9d9d9;
  // border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 36px;
  // color: #8c939d;
  text-align: center;
  // border: 1px solid #eee;
  border-radius: 4px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.brand-icon {
  margin-top: 25px;
  width: 75px;
  height: 75px;
  display: block;
}

.avatar-uploader-icon.brand-icon {
  line-height: 75px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditAccountInfo.vue